var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.7 25.5",
    style: {
      enableBackground: "new 0 0 39.7 25.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9,13.4l7.8-7.8c1.6-1.6,3.2-3.2,4.8-4.8c0.6-0.8,1.7-0.9,2.5-0.3c0.1,0.1,0.2,0.2,0.3,0.3c1.2,1.2,2.4,2.4,3.6,3.6 c0.8,0.6,0.9,1.7,0.3,2.5C39.2,6.9,39.1,7,39,7.1L21.2,24.8c-0.5,0.8-1.6,1-2.3,0.5c-0.2-0.1-0.3-0.3-0.5-0.5 C12.5,18.9,6.6,13,0.7,7.1c-0.8-0.6-0.9-1.7-0.3-2.4c0.1-0.1,0.2-0.2,0.3-0.3C1.9,3.1,3,2,4.2,0.8s2-1,3,0c4,3.9,7.9,7.9,11.9,11.9 C19.3,12.9,19.6,13.1,19.9,13.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.287800dc51c9d0305ee2c1c62b498385.svg";
export { ForwardRef as ReactComponent };